import { h } from 'preact';
import * as BaseComp from 'components/shared/homeEntButtons/homeEntButtons.js';
// import s from 'components/shared/homeEntButtons/homeEntButtons.sss';

export default class HomeEntButtons extends BaseComp.default {

}
